import { render, staticRenderFns } from "./InputPriceFormElement.vue?vue&type=template&id=69ffbd64&scoped=true&"
import script from "./InputPriceFormElement.vue?vue&type=script&lang=js&"
export * from "./InputPriceFormElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ffbd64",
  null
  
)

export default component.exports